import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/hooks/useLanguage';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

interface BreadcrumbLevel {
  label: string;
  href?: string;
}

interface PostalBreadcrumbProps {
  levels: BreadcrumbLevel[];
}

export function PostalBreadcrumb({ levels }: PostalBreadcrumbProps) {
  const { t } = useTranslation();
  const { lang } = useLanguage();

  return (
    <Breadcrumb className="mb-6">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={`/${lang}/information/postnummer`}>
              {t('navigation.postalCodes')}
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {levels.map((level, i) => (
          <span key={i} className="contents">
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              {i === levels.length - 1 ? (
                <BreadcrumbPage>{level.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link to={level.href!}>{level.label}</Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </span>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
